import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { InformationFlow } from 'ThreeTerminal_mobile';
import errorBoundary from '@ifeng/errorBoundary';
import { callApp } from '@ifeng/callapp';
import styles from './index.css';

class FocusNews extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    state = {
        more: true,
        isShowGuideLayer: false,
    };

    // 判断是否是客户端
    isClient = () => {
        return window && typeof window.grounds !== 'undefined';
    };

    handleMoreData = async () => {
        if (this.isClient()) {
            window.grounds.dispatch('topic3', 'https://nine.ifeng.com/newTopic?topicid=7uZ62QOr13g&json=y');
        } else {
            callApp({
                client: 'newsApp',
                docType: 'web',
                pid: 'https://ishare.ifeng.com/c/s/80kdzDaUKoa',
                kind: 'inter_dsjzt01',
                noKindFrom: 1,
                download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1473191364941',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8819',
            });
        }
    };
    render() {
        const { content } = this.props;

        return (
            <div className={styles.focusNews}>
                <div className={styles.focusNewsMd}>
                    <img
                        className={styles.focusNewsMdImg}
                        src="https://x0.ifengimg.com/ucms/2020_43/F98A7600F22C75EC7631AFA71FD37420B5A15739_w254_h110.png"
                    />
                </div>
                <div className={styles.focusNewsBd}>
                    <InformationFlow
                        content={content.slice(0, 5)}
                        isLazyImage={true}
                        isSpreadMoreIcon={true}
                        handleLoadingDataFunc={this.handleMoreData}
                        isDisplayLoadingMore={this.state.more}
                        getExposureData={this.getExposureData}
                        moreText={'查看更多'}
                    />
                </div>
            </div>
        );
    }
}

export default errorBoundary(FocusNews);
